import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { NotifierStateType } from 'moduleChatNotifier/types/NotifierStateType';
import { CHAT_NOTIFIER_LOAD_SUCCESS } from 'moduleChatNotifier/constants';
import { NotifierLoadSuccessPayloadType } from 'moduleChatNotifier/actions/types/NotifierLoadSuccessPayloadType';

const defaultState = {};

const reducerChatNotifier = (
  state: NotifierStateType = defaultState,
  action: ActionWithPayload,
): NotifierStateType => {
  switch (action.type) {
    case CHAT_NOTIFIER_LOAD_SUCCESS: {
      const payload = action.payload as NotifierLoadSuccessPayloadType;
      return {
        ...state,
        countNotViewed: payload.countNotViewed,
      };
    }
    default:
      return state;
  }
};

export { reducerChatNotifier };
